import type { DependencyList } from "react";
import { useLayoutEffect, useRef, useState } from "react";

const useHorizontalOverflowContainerDetection = (deps: DependencyList) => {
  const containerRef = useRef<HTMLElement>(null);
  const [hasOverflow, setHasOverflow] = useState(false);

  const updateOverflow = () => {
    if (containerRef.current) {
      setHasOverflow(containerRef.current.scrollWidth > containerRef.current.clientWidth);
    }
  };

  useLayoutEffect(() => {
    updateOverflow();
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, [...deps]);

  useLayoutEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    const observer = new ResizeObserver(updateOverflow);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return { hasOverflow, containerRef };
};

export default useHorizontalOverflowContainerDetection;
